<template>
  <div class="shadow" align-h="between" :class="$style.borderLeft">
    <b-row class="p-3">
      <b-col
        v-for="(getData, ind) in getRecords"
        :key="ind"
        class="col-12 col-md-6"
        :class="getRecords.length - 1 === ind ? ' ' : 'border-right'"
      >
        <b-row>
          <b-col
            v-for="(data, index) in getData"
            :key="data.label"
            :class="$style.wordBreak"
            class="pb-3"
            :cols="getData.length <= 2 || getData.length - 1 === index ? 6 : 6"
          >
            <strong> {{ data.label }}</strong>
            <div>{{ data.text }}{{ data.child ? ',' : '' }}</div>
            <div>{{ data.child }}</div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    reportData: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    getRecords() {
      return this.reportData
    },
  },
}
</script>

<style lang="scss" module>
@import '@design';
.borderLeft {
  border-left: 5px solid #4b868f;
}
.wordBreak {
  word-break: break-all;
}
</style>
